export default {
  title: {
    id: 'merchant_options_markets',
    defaultMessage: 'Markets',
  },
  opened: {
    id: 'merchant_options_markets_open_in_following_markets',
    defaultMessage: 'You are open in the following markets',
  },
  openable: {
    id: 'merchant_options_markets_could_open_following_markets',
    defaultMessage:
      'Thanks to Back Market, you could open the following markets',
  },
}
